export const FORM_NAME = 'EditScheduledRentForm';
export const INPUT_HEIGHT = 40;
